import React from 'react';

// Se uma página der erro ao ser desenhada, mostra uma mensagem em vez de deixar
// o site inteiro em branco. O menu e o rodapé ficam de fora e continuam a
// funcionar, por isso o visitante pode navegar para outra página.
// Em App.js recebe key={pathname}, o que a repõe ao mudar de página.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: false };
  }

  static getDerivedStateFromError() {
    return { erro: true };
  }

  componentDidCatch(erro, info) {
    // eslint-disable-next-line no-console
    console.error('Erro ao desenhar a página:', erro, info?.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div className="text-center py-24 px-4">
        <div className="text-4xl mb-4">🌿</div>
        <h1 className="text-2xl font-semibold mb-3" style={{ color: '#2E2C29' }}>Ocorreu um problema ao abrir esta página</h1>
        <p className="mb-6" style={{ color: '#706b63' }}>
          Tente recarregar a página. Se o problema continuar, volte ao início ou contacte-nos.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-6 py-2.5 rounded-full text-sm font-semibold transition hover:opacity-90"
            style={{ backgroundColor: '#B89547', color: '#FEFEFD' }}
          >
            Recarregar a página
          </button>
          <a
            href="/"
            className="px-6 py-2.5 rounded-full text-sm font-semibold border transition hover:opacity-80"
            style={{ borderColor: '#B89547', color: '#9A7C38' }}
          >
            Ir para o início
          </a>
        </div>
      </div>
    );
  }
}
